<template>
  <div class="header-search">
    <TextInput class="header-search-input" placeholder="Пошук.." />
  </div>
</template>

<script>
import { TextInput } from '@/shared/ui/form';

export default {
  components: { TextInput }
};
</script>

<style scoped>
.header-search-input {
  width: 300px;
  margin: auto 32px auto auto;

  ::placeholder {
    color: #52525B;
  }
}
</style>
